export const fonts = {
  bold: 'ZeitungMonoPro-Bold, Cairo-Bold',
  regular: 'ZeitungMonoPro-Reg, Cairo-Regular',
};

export const spacing = {
  mobile: '24px',
  desktop: '48px',
};

export const colors = {
  blue: '#4c00ff',
};

export const breakpoints = {
  mobile: 420,
  mobile__l: 580,
  tablet: 768,
  laptop: 1024,
  desktop: 1440,
  bigDisplay: 1920,
};

export const main_nav_height = {
  mobile: '82px',
  laptop: '82px',
  desktop: '102px',
};

export const content_nav_height = {
  mobile: '82px',
  laptop: '30vh',
  desktop: '60vh',
};

export const side_content_width = {
  laptop: '440px',
  desktop: '520px',
};
